import model from '../Apis/Certifications'
import Controller from './Controller'

export default class CertificationsController extends Controller {
  constructor() {
    super(new model())
  }
  async student() {
    const response = await this.model.student()
    return response
  }
  async CretificateStudents(params) {
    const response = await this.model.CretificateStudents(params)
    return response
  }
}
